// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"db49e259","692":"d13adb32"}[chunkId] + ".chunk.css";
};